<div class="container-fluid animated fadeIn">
	<div class="page-header-wrapper">
		<div class="page-header">
			<div class="page-header-left">
				<h2>
					{{ 'financier-companies.pageTitle' | translate }}
				</h2>
			</div>
		</div>
	</div>

	<!-- CONTENT -->
	<app-search-companies
		#searchFinanciersComponent
		class="top-line"
		[searchOnInit]="true"
		[onlyFinanciers]="true">
	</app-search-companies>
</div>
